<template>
  <div id="cartProductList">
    <h1 v-if="position == 'cart'"> {{getText.yourCart}} </h1>
    <ul id="productList">
      <li v-for="(order, forIndex) in getOrder.products" :key="forIndex" class="productListElement">
        <v-card
        class="mx-auto"
    max-width="350"
    width="350"
      >
      <v-card-title class="title">{{ order.name }}</v-card-title>

      <div v-if="order.product == 'table' && order.choosePlanks && position == 'cart'" :style="{'width':imageWidth[forIndex], 'margin-left':'calc((100% - ' + imageWidth[forIndex] + ')/2)' }">
        <v-img
          :src="require('./../../public/img/tablePlankPictures/' + order.plank1 )"
          :height="imageHeight[forIndex]"
          :width="imageWidth[forIndex]"
        ></v-img>
        <v-img
          :src="require('./../../public/img/tablePlankPictures/' + order.plank2 )"
          :height="imageHeight[forIndex]"
          :width="imageWidth[forIndex]"
        ></v-img>
        <v-img
          v-if="order.numberOfPlanks > 2"
          :src="require('./../../public/img/tablePlankPictures/' + order.plank3 )"
          :height="imageHeight[forIndex]"
          :width="imageWidth[forIndex]"
        ></v-img>
        <v-img
          v-if="order.numberOfPlanks > 3"
          :src="require('./../../public/img/tablePlankPictures/' + order.plank4 )"
          :height="imageHeight[forIndex]"
          :width="imageWidth[forIndex]"
        ></v-img>
      </div>

      <div v-if="order.product == 'tableOffice' && position == 'cart'" :style="{'width':imageWidth[forIndex], 'margin-left':'calc((100% - ' + imageWidth[forIndex] + ')/2)' }">
        <v-img
          :src="require('./../../public/img/tableOfficePlankPictures/' + order.plank1 )"
          :height="imageHeight[forIndex]"
          :width="imageWidth[forIndex]"
        ></v-img>
      </div>

      <div v-if="order.product == 'bench' && order.choosePlanks && position == 'cart'" :style="{'width':imageWidth[forIndex], 'margin-left':'calc((100% - ' + imageWidth[forIndex] + ')/2)' }">
        <v-img
          :src="require('./../../public/img/benchPlankPictures/' + order.plank1 )"
          :height="imageHeight[forIndex]"
          :width="imageWidth[forIndex]"
        ></v-img>
      </div>

      <v-card-subtitle class="description" v-if="order.product != 'shelf' && order.product != 'tableOffice' && order.product != 'sample'">
        {{getText.dimensions}}{{order.length}}cm x {{order.width}}cm x {{order.height}}cm <br />
        {{getText.frame}}{{order.frameName}} in {{order.colorName}} <span :style="{'background-color': order.color}" style=" border:1px solid #2c3e50"><span style="visibility:hidden;">hfrefallo</span></span><br />
        <span v-if="!order.discount">{{getText.price}}{{order.price}}€</span>
        <span v-if="order.discount">{{getText.originalPrice}}{{order.price}}€</span><br>
        <span v-if="order.discount">{{getText.discount}}{{order.discountAmount}}€</span><br>
        <span v-if="order.discount">{{getText.discountPrice}}{{order.discountPrice}}€</span>
      </v-card-subtitle>
      <v-card-subtitle class="description" v-if="order.product == 'tableOffice'">
        {{getText.dimensions}}{{order.length}}cm x {{order.width}}cm x 67-127cm <br />
        {{getText.frame}}{{order.frameName}} in {{order.colorName}} <span :style="{'background-color': order.color}" style=" border:1px solid #2c3e50"><span style="visibility:hidden;">hfrefallo</span></span><br />
        <span v-if="!order.discount">{{getText.price}}{{order.price}}€</span>
        <span v-if="order.discount">{{getText.originalPrice}}{{order.price}}€</span><br>
        <span v-if="order.discount">{{getText.discount}}{{order.discountAmount}}€</span><br>
        <span v-if="order.discount">{{getText.discountPrice}}{{order.discountPrice}}€</span>
      </v-card-subtitle>
      <v-card-subtitle class="description" v-if="order.product == 'shelf'">
        {{getText.dimensionsShelf}}{{order.width}}cm x {{order.height}}cm x 30cm <br />
        {{getText.colorShelf}} {{order.colorName}} <span :style="{'background-color': order.color}" style=" border:1px solid #2c3e50"><span style="visibility:hidden;">hfrefallo</span></span><br />
        {{getText.shelfNumberPillars}}{{order.numberOfPillars}} <br />
        {{getText.shelfNumberBoards}}{{order.numberOfPlanks}} <br />
        <span v-if="!order.discount">{{getText.price}}{{order.price}}€</span>
        <span v-if="order.discount">{{getText.originalPrice}}{{order.price}}€</span><br>
        <span v-if="order.discount">{{getText.discount}}{{order.discountAmount}}€</span><br>
        <span v-if="order.discount">{{getText.discountPrice}}{{order.discountPrice}}€</span>
      </v-card-subtitle>

    <v-card-actions @click="removeProduct(forIndex)" v-if="position == 'cart'">
      <v-spacer></v-spacer>
      <v-btn icon color="var(--accentColor)">
        <img class="containerX" src="/icons/x.svg" width="15px"/>
      </v-btn>
    </v-card-actions>
        </v-card>
      </li>
    </ul>
  </div>
</template>

<script>

export default {
  name: 'CartProductList',
  components: {
    // HelloWorld
  },
  props: ['position', 'products'],
  data() {
    return{
      imageFile: "./../../public/img/tablePlankPictures/plank02.jpeg",
      imageFileEnd: "plank02.jpeg",
      imageWidth: [],
      imageHeight:[],
    }
   },
   computed: {
     getOrder(){
       if(this.position == "completed"){
         return this.products
       } else {
         return this.$store.getters.getOrder;
       }
     },
     getText(){ return this.$store.getters.getText.cart.productList },
   },
   mounted () {
     if(this.position != "completed"){
       this.getPlankImageDimensions()
     }
   },
   methods: {
     removeProduct(index){
       this.$store.dispatch("deleteFromCart", index)
     },
     getPlankImageDimensions(){
       var i;
       for (i=0;i<this.getOrder.products.length;i++){
        var width = Math.floor(this.getOrder.products[i].length/220*350) + 'px'
        this.imageWidth.push(width)
        var height = Math.floor(this.getOrder.products[i].width/220*350/this.getOrder.products[i].numberOfPlanks) + 'px'
        this.imageHeight.push(height)
       }
     },
   }
}
</script>

<style scoped>
  ul{
    padding: 0;
  }
  .title{
    font-family: 'Mina' !important;
    color: var(--mainColor);
  }
  .description {
    font-family: 'PT Sans' !important;
    color: var(--mainColor) !important;
    padding-left: 17px;
    text-align: left;
  }
  #cartProductList{
    /* padding: 0 10px; */
    margin: auto;
    width: 350px;
    position: relative;
  }
  .productListElement{
    margin: 5px 0;
    padding: 5px 0;
    width: 100%;
    display: grid;
    grid-template-columns: 160px 1fr 25px;
  }

</style>
